import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TicketsComponent } from './tickets.component';
import { MaterialModule } from 'src/app/material.module';
import { ExtraComponentModule } from '../../components/extra.component.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslocoModule } from '@ngneat/transloco';
const routes: Routes = [{ path: '', component: TicketsComponent }];

@NgModule({
  declarations: [TicketsComponent],
  imports: [CommonModule, RouterModule.forChild(routes), TranslocoModule, MaterialModule, ExtraComponentModule, AngularSvgIconModule],
})
export class TicketsRoutingModule {}
